<template>
  <v-col>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      v-model="menu"
      :nudge-right="40"
      :return-value.sync="date"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-on="on"
          v-model="date"
          prepend-icon="mdi-calendar"
          readonly
          :label="textoPicker"
        ></v-text-field>
      </template>
      <v-date-picker v-model="date" no-title scrollable>
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="$refs.menu.save(date), fechaSeleccionada()">OK</v-btn>
      </v-date-picker>
    </v-menu>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      date: null,
      menu: false,
      modal: false,
      textoPicker: ""
    };
  },
  props: ["label", "fecha", "idGrupo", "seccion"],
  watch: {},
  /*computed: function() {
    let fechaAux = this.fecha.split(" ");
    fechaAux = fechaAux[0];

    this.date = fechaAux;
  },*/
  mounted: function() {
    //console.log("datePicker mounted !");
    if (this.fecha != undefined) {
      let fechaAux = this.fecha.split(" ");
      fechaAux = fechaAux[0];

      this.date = fechaAux;
    }

    if (this.label == "Fecha de Nacimiento")
      this.textoPicker = "Fecha de Nacimiento";
  },
  methods: {
    fechaSeleccionada: function() {
      //console.log("datePiker fechaSeleccionada", this.date, this.idGrupo);
      this.$emit(
        "datePicker:cambiarFechaGrupo",
        this.label,
        this.date,
        this.idGrupo,
        this.seccion
      );
    }
  }
};
</script>

<style scoped>
</style>